export const COMPLETION_STATUS = [
  { id: 'completed', name: 'Completed' },
  { id: 'incompleted', name: 'Incompleted' },
];
